import { type AnchorTarget, Color } from '../../../core/enums';
import makeAtom from '../../../core/makeAtom';
import type { Theme, Tools } from '../../../core/types';
import withEventTracking from '../../../utilities/withEventTracking';
import styles from './index.module.less';
export interface Props {
  Component?: keyof React.ReactHTML | React.ElementType;
  children?: React.ReactNode;
  className?: string;
  theme?: Theme;
  href?: string;
  target?: AnchorTarget;
  onClick?: (args: unknown) => void;
  tools?: Tools;
  qeId?: string;
}

export const Link = makeAtom<Props>({
  name: 'Link',
  defaultProps: {
    Component: 'a',
    theme: {
      color: Color.BrightBlue,
      textBody: 3,
    },
    tools: {
      tracking: {
        methods: ['click'],
      },
    },
  },
  rootClass: styles.root,
  styles,
});

export default withEventTracking<Props>(Link);
